import { useState } from 'react'

import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { useDataLoader } from '../../../../../../hooks'
import { getMockCalendarBuildings } from '../../../../Calendar.mock'
import { isCalendarRailBuildingListEmpty } from '../../CalendarRailBuilding.utils'

// The first page is read on mount: a company with no building gets a disabled select (CAL-01 §9.1 "Rail")
export function useCalendarRailBuildings() {
  const [isListFailed, setListFailed] = useState(false)

  // TODO: search the real buildings and building groups once the calendar feed filters by them
  async function getBuildings(params) {
    return getMockCalendarBuildings(params)
      .then(response => {
        setListFailed(false)

        return response
      })
      .catch(error => {
        setListFailed(true)

        throw error
      })
  }

  async function getFirstBuildings() {
    return getBuildings(EMPTY_OBJECT)
  }

  const { data: isListEmpty, isLoading } = useDataLoader({
    getData: getFirstBuildings,
    getResponseData: isCalendarRailBuildingListEmpty,
  })

  return { getBuildings, hasBuildings: !isListEmpty, isListFailed, isLoading }
}
